export default {
  subheadline: 'Diese Einstellungen legen fest, wie Qmulus Ihr Unternehmen darstellt, z. B. in der Kopfzeile von PDF-Berichten.',
};
